/** Previous / Next for the paged inbox lists (tracker item 45). */
import React from 'react';
import { secondaryButtonClass } from './formStyles';

interface Props {
  page: number;
  pages: number;
  total: number;
  onPage: (page: number) => void;
  disabled?: boolean;
}

export function RequestPager({ page, pages, total, onPage, disabled }: Props) {
  if (pages <= 1) return <p className="mt-3 text-xs text-gray-500">{total} total</p>;
  return (
    <nav aria-label="Pages" className="mt-4 flex items-center justify-between gap-3">
      <button type="button" className={secondaryButtonClass} disabled={disabled || page <= 1} onClick={() => onPage(page - 1)}>Previous</button>
      <span className="text-sm text-gray-600">Page {page} of {pages} ({total} total)</span>
      <button type="button" className={secondaryButtonClass} disabled={disabled || page >= pages} onClick={() => onPage(page + 1)}>Next</button>
    </nav>
  );
}
